import React, {useEffect, useRef} from "react";
import {createPortal} from "react-dom";
import Icon from "./Icon";

// Accessible modal: closes on Escape and on backdrop click, and focuses itself when opened.
const Modal = ({open = true, onClose, title, children, footer, size, className = "", labelledBy, hideClose}) => {
    const dialogRef = useRef(null);
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!open) return;
        const handleKey = (event) => {
            if (event.key === "Escape" && onCloseRef.current) onCloseRef.current();
        };
        window.addEventListener("keydown", handleKey);
        dialogRef.current?.focus();
        return () => window.removeEventListener("keydown", handleKey);
    }, [open]);

    if (!open) return null;

    // Rendered at the end of <body>, so the modal is never clipped or offset by the card it was opened from
    return createPortal(
        <div className="modal-backdrop" onMouseDown={(e) => {
            if (e.target === e.currentTarget && onClose) onClose();
        }}>
            <div
                ref={dialogRef}
                className={`modal ${size === "sm" ? "modal--sm" : ""} ${className}`}
                role="dialog"
                aria-modal="true"
                aria-labelledby={labelledBy}
                tabIndex={-1}
            >
                {(title || (onClose && !hideClose)) && (
                    <div className="modal-header">
                        {title ? <h2 id={labelledBy} style={{fontSize: "1.3rem"}}>{title}</h2> : <span/>}
                        {onClose && !hideClose && (
                            <button className="icon-btn" onClick={onClose} aria-label="Close">
                                <Icon name="close"/>
                            </button>
                        )}
                    </div>
                )}
                {children}
                {footer && <div className="modal-footer">{footer}</div>}
            </div>
        </div>,
        document.body
    );
};

export default Modal;
